<div class="">
    <div class="text-center" style="padding: 15px">
        <img
            src="/assets/logo/logo{{ client }}.png"
            width="200"
            height="60"
            style="object-fit: contain"
        />
        <div class="connect">
            <span>
                <ng-container *ngIf="client === '-ironside'; else elseTemplateTileT">
                    <strong>Password recovery</strong>
                </ng-container>
                <ng-template #elseTemplateTileT>
                    <strong>Récupération de mot de passe</strong>
                </ng-template>
            </span>
        </div>
        <div class="Saisissez">
            <p>
                <ng-container *ngIf="client === '-ironside'; else elseTemplateDescription">
                    Please enter your username and follow the instructions sent by email to reset
                    your password.
                </ng-container>
                <ng-template #elseTemplateDescription>
                    Saisissez votre identifiant, et suivez la démarche à suivre reçu par email afin
                    de renouveler votre mot de passe.
                </ng-template>
            </p>
        </div>
        <form ngNativeValidate #form>
            <div class="formulaire" style="position: relative">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>
                            <ng-container *ngIf="client === '-ironside'; else elseTemplateYourName">
                                Your username
                            </ng-container>
                            <ng-template #elseTemplateYourName> Votre identifiant </ng-template>
                        </mat-label>
                        <div *ngIf="client === '-ironside'; else elseBlock">
                            <input
                                matInput
                                type="text"
                                name="Votre identifiant"
                                [placeholder]="
                                    client === '-ironside'
                                        ? 'fisrtname.lastname@domain.com'
                                        : 'nom.prenom@eurochef.fr'
                                "
                                [(ngModel)]="username"
                            />
                        </div>
                        <ng-template #elseBlock>
                            <input
                                matInput
                                type="text"
                                name="Votre identifiant"
                                placeholder="Identifiant"
                                [(ngModel)]="username"
                            />
                        </ng-template>
                    </mat-form-field>
                </div>

                <div style="margin-top: 2vh; margin-bottom: 2vh">
                    <!-- <button mat-button  style="color:white; background-color: rgb(21, 113, 189); padding: 8px; border-radius: 5px;"(click)="submit()">SE CONNECTER</button> -->
                    <button
                        type="submit"
                        class="btn-primary mb-2"
                        mat-raised-button
                        (click)="envoyer()"
                        [disabled]="!validBtn || !username"
                    >
                        <ng-container *ngIf="client === '-ironside'; else elseTemplateBtnSend">
                            Send
                        </ng-container>
                        <ng-template #elseTemplateBtnSend> Envoyer </ng-template>
                    </button>
                </div>

                <p class="err" [ngStyle]="{ visibility: invalidLogin ? '' : 'hidden' }">
                    <ng-container *ngIf="client === '-ironside'; else elseTemplateDesErr1">
                        If you don't have an account on the platform, please contact an
                        administrator.
                    </ng-container>
                    <ng-template #elseTemplateDesErr1>
                        Vous n'avez pas de compte sur la plateforme, veuillez-vous rapprocher d'un
                        administrateur.
                    </ng-template>
                </p>
                <p class="msg" [ngStyle]="{ visibility: wellSent ? '' : 'hidden' }">
                    <ng-container *ngIf="client === '-ironside'; else elseTemplateErr2">
                        A password reset link has been sent to your email address
                    </ng-container>
                    <ng-template #elseTemplateErr2>
                        Un lien de renouvellement de mot de passe vous a été envoyé
                    </ng-template>
                </p>
                <p class="err" [ngStyle]="{ visibility: error ? '' : 'hidden' }">
                    <ng-container *ngIf="client; else elseTemplateErr3">
                        An error has occurred, please try again.
                    </ng-container>
                    <ng-template #elseTemplateErr3>
                        Une erreur est survenue, veuillez réessayer
                    </ng-template>
                </p>
                <p class="err" [ngStyle]="{ visibility: inactiveAccount ? '' : 'hidden' }">
                    <ng-container *ngIf="client === '-ironside'; else elseTemplateErr4">
                        Your account is inactive, please contact an administrator.
                    </ng-container>
                    <ng-template #elseTemplateErr4>
                        Votre compte est inactif, veuillez-vous rapprocher d'un administrateur.
                    </ng-template>
                </p>
            </div>
        </form>
    </div>
</div>
